import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import moment from 'moment';
import find from 'ramda/src/find';
import prop from 'ramda/src/prop';
import reverse from 'ramda/src/reverse';
import sortBy from 'ramda/src/sortBy';
import AdsCard from '@components/AdsCard';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import Icon from '@components/@core/Icon';

const RecentDepartment = ({ department, adsData, index }) => {
    const navigate = useNavigate();
    const zone_id =
        index === 0 ? 99537 : index === 1 ? 99539 : index === 2 ? 99540 : index === 3 ? 99541 : index === 4 ? 99542 : index === 5 ? 99544 : index === 6 ? 99545 : index === 7 ? 99587 : 99588;
    const _allTopics = useSelector((state) => state.community.allTopics);
    const appId = useSelector((state) => state.app.user?.community_user?.id);
    const _department = find((top) => top.id === department.id, _allTopics ?? []);
    const _topics = (_department?.topics ?? []).map((e) => {
        const { comments } = e;
        return { ...e, comment_at: comments ? comments[comments.length - 1].created_at : '' };
    });
    const topics = reverse(sortBy(prop('comment_at'), _topics));

    const handleSeeMore = () => navigate(`/community/forum-department-feed/${department.id}`);

    return (
        <div className="card recent-department-card">
            <p className="dsl-b18 bold title">{department.name}</p>
            {topics?.length > 0 ? (
                <>
                    {topics.map((item, idx) =>
                        idx === 2 ? (
                            <>
                                <broadstreet-zone zone-id={zone_id}></broadstreet-zone>
                                <AdsCard key={`ads-${idx}`} className="list-item" size="tiny" data={adsData} />
                            </>
                        ) : (
                            <div className="d-flex list-item cursor-pointer" key={idx} onClick={() => navigate(`/community/forums/${item.id}/${department.id}`)}>
                                <div className="d-h-start">
                                    <Avatar
                                        className="mr-3"
                                        url={item.comments[0]?.author_avatar}
                                        name={`${item.comments[0]?.user?.first_name} ${item.comments[0]?.user?.last_name}`}
                                        isSponsored={true}
                                    />
                                </div>
                                <div className="d-flex d-flex-1">
                                    <div className="d-flex-5">
                                        <p className="dsl-b14 bold truncate-one mb-0">{item?.name}</p>
                                        <span className="mr-1 dsl-m12 text-400">{`Created by: ${item.comments[0]?.user?.first_name} ${item.comments[0]?.user?.last_name}`}</span>
                                        <div className="d-flex">
                                            <Icon name="far fa-eye me-2 text-500" size={12} color="#969faa" />
                                            <span className="dsl-d12 me-4">{item?.stats?.views || 0}</span>
                                            <Icon name="fas fa-thumbs-up me-2 text-500" size={12} color={item?.stats?.liked && appId && item?.stats?.liked[appId] ? '#376caf' : '#969faa'} />
                                            <span className={cx('dsl-d12 me-4', item?.stats?.liked && appId && item?.stats?.liked[appId] && 'text-primary')}>{item?.stats?.likes || 0}</span>
                                            <Icon name="far fa-comment me-2 text-500" size={12} color={item?.comments.some((comment) => comment.user_id === appId) ? '#376caf' : '#969faa'} />
                                            <span className={cx('dsl-d12 me-4', item?.comments.some((comment) => comment.user_id === appId) && 'text-primary')}>{item?.stats?.comments || 0}</span>
                                        </div>
                                    </div>
                                    <div className="d-flex-1 mb-auto">
                                        <p className="dsl-b12 text-nowrap text-end">{moment.utc(item.comment_at).fromNow()}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    )}
                    <Button className="ml-auto me-3" name="See More" type="link" onClick={handleSeeMore} />
                </>
            ) : adsData ? (
                <AdsCard className="list-item" size="tiny" data={adsData} />
            ) : (
                <div className="dsl-m14 text-center">No recent {department.name} available</div>
            )}
        </div>
    );
};

export default RecentDepartment;
